import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  FileAttachedDocumentType,
  FileMessageFlow,
  FileMessageSenderType,
} from '@savgroup-front-common/constants/shared/message';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

export interface FileMessageAttachedDocumentResponse {
  documentUrl?: string;
  documentExtension?: string;
  displayName?: string;
  attachedDocumentType: FileAttachedDocumentType;
}

export interface FileMessageResponse {
  id: string;
  senderType: FileMessageSenderType;
  recipientType: FileMessageSenderType;
  messageDate: string;
  attachedDocuments?: FileMessageAttachedDocumentResponse[];
  messageContent?: string;
  from?: string;
  messageFlow: FileMessageFlow;
}

interface GetFileMessagesQueryPayload {
  fileId: string;
}

export async function getFileMessagesQuery({
  fileId,
}: GetFileMessagesQueryPayload): Promise<
  BackResponse<FileMessageResponse[] | undefined> | BackResponseFailure
> {
  try {
    return await apiCall<BackResponse<FileMessageResponse[] | undefined>>(
      `${APIConfiguration.workflow}files/${fileId}/messages`,
      {
        method: SUPPORTED_METHODS.GET,
      },
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
}
